import type { PGD } from "../types";

export const pgdDoxycyclineSinusitis: PGD = {
  id: "pgd-6e-doxy-sinusitis",
  reference: "6e",
  version: "1.0",
  drugRef: "doxycycline",
  indication: "Acute sinusitis — penicillin allergy, not pregnant",
  validFrom: "2024-01-31",
  expiryDate: "2027-01-30",
  frameworkType: "pharmacy_first",
  population: {
    ageRange: { min: 12, max: 999 },
    pregnancyAllowed: false,
    breastfeedingAllowed: false,
  },
  duration: { days: 5, comment: "Loading-dose schedule: 200mg on day 1, then 100mg daily on days 2–5." },
  doseBands: [
    {
      id: "doxy-age12plus",
      resolveBy: "single",
      ageRange: { min: 12, max: 999 },
      dose: "200mg on day 1, then 100mg daily",
      frequency: "ONCE daily",
      formulations: [
        {
          formulationId: "doxy-100-cap",
          instruction: "Take TWO 100mg capsules on day 1, then ONE 100mg capsule ONCE daily on days 2 to 5",
          quantity: { count: 6, label: "6 capsules" },
        },
      ],
    },
  ],
  // Pre-supply checks — items already covered by pathway pre-screening are omitted:
  // All exclusion checks handled upfront in the pathway (q_general_exclusions,
  // q_myasthenia_check, q_doxy_screen). No post-selection checks needed.
  preSupplyChecks: [],
  cautions: [
    { id: "caution-oesophagitis", text: "Oesophageal irritation — take with plenty of water and remain upright." },
    { id: "caution-photosensitivity", text: "Photosensitivity can occur — advise sun protection." },
  ],
  counselling: [
    "Take with food or water",
    "Swallow capsules whole with a full glass of water while sitting or standing",
    "Do not lie down immediately after taking a dose",
    "Avoid excessive sunlight or sunbeds during treatment",
    "Complete the full 5-day course even if symptoms improve",
  ],
  counsellingPoints: [
    { text: "Take with food or water" },
    { text: "Swallow capsules whole with a full glass of water while sitting or standing" },
    { text: "Do not lie down immediately after taking a dose" },
    { text: "Avoid excessive sunlight or sunbeds during treatment" },
    { text: "Complete the full 5-day course even if symptoms improve" },
  ],
  outcomeLinkRefs: ["target-rti-leaflet", "nhs-sinusitis"],
};
